<template>
  <div>
    <div class="note-card">
      <div class="note-header">
        <span class="note-date">2 days ago</span>
        <span class="note-menu">
          <!-- <span style="font-size:1.75em;font-weight:bold">&#8943;</span> -->
          <b-dropdown
            size="lg"
            variant="outline"
            right
            toggle-class="text-decoration-none"
            style="color:gray"
            no-caret
          >
            <template slot="button-content">&#8943;<span class="sr-only">Search</span></template>
            <b-dropdown-item href="#">Edit</b-dropdown-item>
            <b-dropdown-item href="#">Copy Text</b-dropdown-item>
            <b-dropdown-item href="#">Delete</b-dropdown-item>
          </b-dropdown>
        </span>
      </div>
      <div
        class="note-text"
        v-html="highlightHashtags()"
      ></div>
      <!-- <div class="note-text">
      It is the <span @click='handleClick'><strong>Trial</strong></span> of the century
    </div> -->
      <div class="note-image">
        <img :src="img" />
      </div>
    </div>
    <div class="note-spacer">
    </div>
  </div>
</template>

<script>
export default {
  name: "Card",
  props: {
    text: String,
    img: String
  },
  data() {
    return {
      query: "[#]\\w\\S*\\b", // Find hashtags
      note: {
        text: this.text,
        img: this.img
      }
    };
  },
  methods: {
    highlightHashtags() {
      if (!this.query) {
        return this.content;
      }
      return this.note.text.replace(new RegExp(this.query, "gi"), match => {
        console.log("match found: ", match);
        return (
          "<a href='/search/" +
          "TODO" +
          "' style='color:black'><strong>" +
          match +
          "</strong></a>"
        );
      });
    },
    handleClick() {
      console.log("handled!");
    }
  }
};
</script>

<style scoped>
.note-card {
  background: white;
  width: 100%;
  max-width: 500px;
  text-align: left;
  border-style: none;
  margin: 0 auto;
}

.note-spacer {
  height: 30px;
}

.note-header {
  height: 40px;
  padding-left: 10px;
  padding-right: 0px;
  font-size: 12px;

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: stretch;
}

.note-header span {
  vertical-align: middle;
  line-height: 40px;
}

.note-date {
  font-size: 12px;
  color: gray;
  vertical-align: middle;
}

.note-menu {
  /* float: right; */
  vertical-align: middle;
}

.note-text {
  padding: 10px;
  padding-top: 0px;
  font-size: 16px;
}

.note-image img {
  width: 100%;
  height: auto;
  vertical-align: middle; /* this gets rid of margin on bottom of image */
  border-radius: 0px;
}

@media (min-width: 500px) {
  .note-card {
    max-width: 500px;
    border: 1px solid gainsboro;
    border-radius: 2px;
    margin-top: 20px;
  }
}

/* Small devices (landscape phones, 576px and up) */
@media (min-width: 576px) {
}

/* Medium devices (tablets, 768px and up) */
@media (min-width: 768px) {
}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) {
}

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {
  .note-card {
    max-width: 700px;
  }
}
</style>
